import React from 'react';

export const ShowCardSkeleton = () => (
  <div className="show-row">
    <div className="show-card" style={{ border: 'none', background: 'var(--background-secondary)' }}>
      <div className="show-poster-container">
        <div className="show-poster skeleton" style={{ border: 'none' }}></div>
      </div>
      <div className="show-info">
        <div className="show-title skeleton" style={{ width: '60%', height: '20px', border: 'none' }}></div>
        <div className="popular-show-metadata">
          <div className="rating-section skeleton" style={{ width: '100px', height: '20px', border: 'none' }}></div>
        </div>
        <div className="streaming-services">
          <div className="streaming-service skeleton" style={{ width: '60px', border: 'none' }}></div>
          <div className="streaming-service skeleton" style={{ width: '60px', border: 'none' }}></div>
        </div>
      </div>
      <div className="show-actions">
        <div className="skeleton" style={{ width: '40px', height: '40px', borderRadius: '4px', border: 'none' }}></div>
        <div className="skeleton" style={{ width: '40px', height: '40px', borderRadius: '4px', border: 'none' }}></div>
      </div>
    </div>
  </div>
); 